export const sales = ['0-10', '11-50', '51-100', '101-500', '501+'];

export const location = [
  {
    label: 'Lagos, Nigeria',
    value: 'Lagos, Nigeria',
  },
];

export const channel = [
  {
    label: 'WhatsApp',
    value: 'whatsapp',
  },
  {
    label: 'Instagram',
    value: 'instagram',
  },
  {
    label: 'Facebook',
    value: 'facebook',
  },
];
